
import './App.css';
import { Outlet } from 'react-router-dom';
import { NavBarNew } from './componentes/navBarNew';
import Footer from './componentes/footer';






function App2() {
	return (
		<>
			<NavBarNew />
			<div className='min-h-screen'>
				<Outlet></Outlet>
			</div>

			<Footer></Footer>
		</>
	);
}

export default App2;
